import images from '@assets/images/index'
import { Alert, Form, Input, Spin } from 'antd'
import { useState } from 'react'

import { UserId } from '@suntex.fim/api-client'
import { AuthError } from '@suntex.fim/auth'
import { useAuth } from '@suntex.fim/auth/react'
import { useTheme } from '@suntex.fim/ui'

import { Button } from './ui'

interface LoginFormValues {
  username: string
  password: string
}

function Login() {
  const { colors } = useTheme()
  const { isLoading, signIn } = useAuth()
  const [error, setError] = useState('')

  const signInWithLoading = async ({ username, password }: LoginFormValues) => {
    setError('')

    try {
      await signIn({
        userId: username as UserId,
        password
      })
    } catch (error) {
      if (error instanceof AuthError) {
        setError(error.message)
      } else {
        setError('Failed to login. Please check your username and password.')
      }
    }
  }

  return (
    <Form<LoginFormValues>
      className="login-wrapper"
      colon={false}
      layout="vertical"
      requiredMark={false}
      onFinish={(values) => void signInWithLoading(values)}
    >
      <h3 className="login-heading">Let&#x27;s Go!</h3>
      <Form.Item
        label={<span className="login-label">Username</span>}
        name="username"
        rules={[
          {
            required: true,
            whitespace: true,
            message: 'Please enter your username.'
          }
        ]}
      >
        <Input
          className="login-input"
          maxLength={256}
          autoComplete="username"
          size="large"
        />
      </Form.Item>

      <Form.Item
        label={<span className="login-label">Password</span>}
        name="password"
        rules={[
          {
            required: true,
            whitespace: true,
            message: 'Please enter your password.'
          }
        ]}
      >
        <Input.Password
          iconRender={(visible) =>
            visible ? <images.Eye /> : <images.EyeSlash />
          }
          autoComplete="current-password"
          className="login-input"
          maxLength={256}
          size="large"
        />
      </Form.Item>
      {error ? <Alert message={error} type="error" showIcon /> : null}
      <Form.Item className="login-submit">
        <Button
          intent="submit"
          size="large"
          disabled={isLoading}
          style={{ backgroundColor: colors.red }}
        >
          Go {isLoading ? <Spin /> : ''}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default Login
